/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  ConfirmWirelessProductConfiguration.tsx
 *
 * Project Title :  Checkout
 *
 * Description	 :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Srinivas Grandhi (E528634)
 *
 * @Date	     : 04 November 2019
 *
 * @Version      : Version 1.0
 *
 * By            : H224423
 * On            : Dec 3, 2019
 * Description   : ASDS-1995 - UI Issue Fixes.
 *
 * By            : Suresh Jaladi (E807958)
 * On            : 3 Dec 2019
 * Description   : ASDS-1958
 *
 * * By             : H422337
 * On             : Sep 10,2020
 * Description    : ASDS-2570 UI enhancements as part of phase-2
 *
 * By             : H422336
 * On             : Oct 06,2020
 * Description    : ASDS-3227 APU enhancements as part of phase-2
 *
 * By            : H422335
 * On            : Oct 27, 2020
 * Description   : ASDS-3269 Migration of backend URLs to Forge endpoints
 *
 ******************************************************************************/

import * as React from 'react';

import { Card,Grid, Icon,Button } from '@scuf/common';
import {DataTable} from '@scuf/datatable';
import './ConfigureWirelessProduct.css';
import 'modules/checkout/ConfigureProduct/ConfigureProduct.css';
import '@scuf/common/honeywell/theme.css';
import { connect } from 'react-redux';
import ConfigureWirelessActions from 'modules/checkout/redux/actions/configure-wireless-actions';

interface IConfigureWirelessProductProps {
  wirelessProductPrice: number;
  aircraftDetailsArray: IAircraftDetailsRowData[];
  aircraftTypes: any;
  gotoPrevTabWireless: any;
}
interface IAircraftDetailsRowData {
  aircraftType: { id: string; name: string; };
  serialNumber: string;
  tailNumber: string;
}

class ConfirmWirelessProductConfiguration extends React.Component<IConfigureWirelessProductProps> {
  render() {
    return (
      <React.Fragment>
        <Card className="fullwidthCard config-confirmation-card-spacing">
          <Card.Content>
            <Grid>
              <Grid.Row>
                <Grid.Column width={12}>
                  <div className="cp-conf-edit"><Icon root="common" name="edit" className="confirmation-edit-icon" size="small" onClick={this.props.gotoPrevTabWireless}/></div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={12} className="cwp-confirmConfigurationTab fullwidthRow">
                  <DataTable
                    data={this.props.aircraftDetailsArray}
                    scrollable={true}
                    scrollHeight="150px"
                    virtualRowHeight={48}
                    resizableColumns={true}
                  >
                    <DataTable.Column field="aircraftType.name" header="Aircraft Type" align="left" renderer={this.statusRenderer} />
                    <DataTable.Column field="serialNumber" header="AirCraft Serial Number" align="left" />
                    <DataTable.Column field="tailNumber" header="Aircraft Tail Number" align="left" />
                  </DataTable>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Card.Content>
        </Card>
        <Card className="fullwidthCard margin-top-0">
          <Card.Content>
            <Grid>
              <Grid.Row>
                <Grid.Column width={8} className="tp-taxDetail-text">
                  <span>If you are tax exempt, please email us the tax certificate to</span>
                </Grid.Column>
                <Grid.Column width={4} className="tp-taxDetail">
                  <span className="tp-total-price-text">Total Price</span>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={8} className="tp-taxDetail-text">
                  <Button  href="mailto:dsa@honeywellaerospace.com" type="link" content="dsa@honeywellaerospace.com" />

                </Grid.Column>
                <Grid.Column width={4} className="tp-taxDetail">
                  <span className="tp-total-price-amount">${(this.props.aircraftDetailsArray.length * this.props.wirelessProductPrice).toFixed(2)}</span>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column className="tp-taxDetail">
                  <span className="tp-taxDetail-taxmsg"> +Taxes as applicable</span>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Card.Content>
        </Card>

      </React.Fragment>
    );
  }
  statusRenderer(cellData) {
    const data = cellData.rowData && cellData.rowData.aircraftType && cellData.rowData.aircraftType.name;
    return <span>{data}</span>;
  }
}
const mapDispatchToProps = {
  gotoPrevTabWireless: ConfigureWirelessActions.gotoPrevTabWireless,
};
function mapStateToProps(state) {
  return {
    aircraftDetailsArray: state.configWirelessProductData.payload.aircraftDetailsArray,
    aircraftTypes: state.configWirelessProductData.payload.aircraftTypes,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmWirelessProductConfiguration);
